import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';
import React from 'react';
import { connect } from 'react-redux';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { onChangeMapFilters } from '../../../ac/onChangeMapFilters';
import * as V from '../../../constants/variables';
import { getUserTapsColorScope } from '../../../utils/getUserTapsColorScope';
import { ColoredItemsLegend } from '../../LegendRenderer/types/ColoredItemsLegend';
import { MultiGroupFilter } from '../MultiGroupFilter';
import { LEGEND_ICON_TYPES } from '../../../types/legendTypes';

const getLabel = (isTaps, value, mode) => `≥ ${value} ${mode === V.SHARE ? ' %' : isTaps ? t`тапов` : t`открытий`}`;
const TapsOpensHistFilterComponent = ({ tapsOpensHistYear, onChangeMapFilters, tapsOpensHistMode, tapsOpensHistPrefix }) => {
    const filterYearValue = tapsOpensHistYear;
    const prefix = tapsOpensHistPrefix;
    const isTaps = prefix === 'taps' || prefix === 'taps_no_starts';
    const isForcedAbsMode = prefix === 'taps_no_starts' || prefix === 'open_to_ride';
    const activeMode = isForcedAbsMode ? V.ABS : tapsOpensHistMode;
    const colorArray = activeMode === 'ABS' ? V.userTapsHexagonColor : V.userTapsHexagonColorSh;
    const onChange = ({ target: { value } }) => {
        const key = 'tapsOpensHistYear';
        onChangeMapFilters(key, +value);
    };
    const onChangeMode = mode => {
        if (!isForcedAbsMode) {
            const key = 'tapsOpensHistMode';
            onChangeMapFilters(key, mode);
        }
    };
    const onChangePrefix = ({ target: { value } }) => {
        const key = 'tapsOpensHistPrefix';
        onChangeMapFilters(key, value);
    };
    const getLegendItems = () => {
        if (prefix === 'taps' || prefix === 'opens') {
            return getUserTapsColorScope(30, activeMode, prefix)
                .map((value, index) => ({
                    id: value,
                    label: { id: `label_${value}`, message: getLabel(isTaps, value, V.ABS) },
                    fill: colorArray[index],
                }))
                .filter((_, index) => index !== 0 || activeMode !== 'ABS');
        } else if (prefix === 'open_to_ride') {
            return V.aggUserOpensToStartsLegend.map(({ label, fill }) => ({
                id: fill,
                label: { id: `label_${fill}`, message: i18n._(label) },
                fill,
            }));
        } else if (prefix === 'taps_no_starts') {
            return V.aggUserTapsZeroStartsLegend7days.map(({ label, fill }) => ({
                id: fill,
                label: { id: `label_${fill}`, message: i18n._(label) },
                fill,
            }));
        }
        return [];
    };
    const legendContent = (
        <div>
            <ColoredItemsLegend
                items={getLegendItems()}
                icon={LEGEND_ICON_TYPES.HEXAGON}
                renderConfig={{
                    showIcon: true,
                    iconSize: '30px',
                    iconOpacity: 0.8,
                    fontSize: '0.85rem',
                }}
            />
            <div style={{ padding: '10px' }}>
                <small>
                    {activeMode === 'ABS' ? t`` : t`Разница в % от среднего значения по региону`}
                </small>
            </div>
        </div>
    );
    return (
        <div>
            <MultiGroupFilter
                isVisible={true}
                groups={[
                    {
                        id: 'mode',
                        type: 'button-group',
                        value: activeMode,
                        onChange: e => onChangeMode(e.target.value),
                        options: V.TapsOpensModeOptions.map(({ type, label }) => ({
                            value: type,
                            label,
                            disabled: isForcedAbsMode && type === V.SHARE,
                        })),
                    },
                    {
                        id: 'prefix',
                        value: prefix,
                        onChange: onChangePrefix,
                        options: V.userTapsOpensHistFilterValues.map(({ value, label }) => ({
                            value,
                            label: i18n._(label),
                        })),
                    },
                    {
                        id: 'year',
                        value: String(filterYearValue),
                        onChange,
                        options: V.userTapsOpensHistYearFilterValues.map(value => ({
                            value,
                            label: t`${value}`,
                        })),
                    },
                ]}
                footer={legendContent}
            />
        </div>
    );
};
const mapStateToProps = ({ mapFilters: { tapsOpensHistYear, tapsOpensHistMode, tapsOpensHistPrefix } }) => ({
    tapsOpensHistYear, tapsOpensHistMode, tapsOpensHistPrefix,
});
const ConnectedComponent = connect(mapStateToProps, { onChangeMapFilters })(TapsOpensHistFilterComponent);

export const TapsOpensHistFilter = withDisplayedLayersCheck(ConnectedComponent, 'Исторические тапы и открытия');

